import axios from "axios";
const myAxios = axios.create({
    baseURL:"/payment",
    timeout:60000
})

// 请求拦截器
myAxios.interceptors.request.use((config)=>{
    // // 请求头携带token
    return config
},(error)=> {
    return Promise.reject(error)
})

// 响应拦截器
myAxios.interceptors.response.use((res)=>{
    // nprogress.done()
    return res.data

},(error)=>{
    return Promise.reject(error)

})

// module.exports = myAxios
export default myAxios
